module.exports = __webpack_public_path__ + "img/energy2.6f8730fc.jpg";